import { ReactNode } from 'react'
import { MarketingFooter } from './MarketingFooter'
import '../styles/marketing.css'

interface MarketingLayoutProps {
  children: ReactNode
}

/**
 * Layout minimalista: solo footer.
 * Cada página de marketing gestiona su propia navegación contextual
 * (logo prominente en hero, CTAs, etc.) para evitar un header redundante
 * que solo contendría logo + login, los cuales ya aparecen en la propia página.
 */
export function MarketingLayout({ children }: MarketingLayoutProps) {
  return (
    <div className="marketing-page marketing-page--no-header">
      <main className="marketing-main">
        {children}
      </main>
      <MarketingFooter />
    </div>
  )
}